<template>
  <div class="etx-container Container" :class="paragraphClassList">
    <div class="etx-center Center">
      <div class="etx-flex Flex tab-s:gv-0">
        <div class="etx-flex__item Flex__item tab-s:c-10 tab-m:c-9 tab-l:c-8 tab-s:ml-2 tab-m:ml-3 tab-l:ml-4">
          <DrupalWebform v-if="contactWebform?.id" :formId="contactWebform?.id" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>

defineProps<{
  isEditing?: boolean
  contactWebform?: Object
}>()

const { options, isEditing } = defineBlokkli({
  bundle: 'contact_form',
  options: {
    spacingTop: {
      type: 'radios',
      label: 'Oben',
      default: 'pt-0',
      group: 'Innenabstände oben und unten',
      options: {
        'pt-0': '0',
        'pt-25': '25',
        'pt-50': '50',
        'pt-75': '75',
        'pt-100': '100',
        'pt-200': '200',
      },
    },
    spacingBottom: {
      type: 'radios',
      label: 'Unte',
      default: 'pb-100',
      group: 'Innenabstände oben und unten',
      options: {
        'pb-0': '0',
        'pb-25': '25',
        'pb-50': '50',
        'pb-75': '75',
        'pb-100': '100',
        'pb-200': '200',
      },
    },
    backgroundColor: {
      type: 'radios',
      label: 'Hintergrundfarbe Color',
      default: 'white',
      displayAs: 'colors',
      options: {
        'white': { class: 'bg-grey-1', label: 'Weiss' },
        'bg-grey-1': { class: 'bg-grey-1', label: 'Hellgrau' },
      },
    },
  },
})

const paragraphClassList = computed(() => {
  const classList = []
  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }
  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }
  if (options.value.backgroundColor !== 'white') {
    classList.push(options.value.backgroundColor)
  }
  return classList
})


</script>